import { MbeBars, MbeClose, MbeSettings } from '@/components/icons';
import { useDisclosure } from '@chakra-ui/hooks';
import {
  Box,
  Button,
  Divider,
  Flex,
  Icon,
  IconButton,
  Slide,
  useMediaQuery,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Menu } from './Menu';
import { ROUTE_PATHS } from '@/constants';
import { NavLink, useNavigate } from 'react-router-dom';
import { Auth } from '@aws-amplify/auth';

export const MenuMobile: React.FC = (): JSX.Element => {
  const { isOpen, onToggle } = useDisclosure();
  const { t } = useTranslation();
  const [isLargerThan768] = useMediaQuery('(min-width: 48em)');
  const navigate = useNavigate();

  const goToPage = (replace = false, path: string): void => {
    navigate(path, { replace });
  };

  const logout = async (): Promise<void> => {
    await Auth.signOut().catch(() => {
      throw new Error('Logout error');
    });

    goToPage(true, ROUTE_PATHS.landing);
  };

  return (
    <>
      <IconButton
        aria-label="Open Menu mobile"
        display={{ base: 'block', md: 'none' }}
        icon={<MbeBars h={8} w={8} />}
        onClick={onToggle}
      />
      <Slide in={!isLargerThan768 && isOpen} style={{ top: 0 }}>
        <Flex bg="white" direction="column" h="100vh">
          <Flex alignItems="center" h="75px" justifyContent="space-between" px="20px" w="100%">
            <Box flexGrow="5">
              <img alt="MBE Auction" src="/images/logo.png" title="MBE" width={180} />
            </Box>
            <NavLink to={ROUTE_PATHS.userSettings}>
              <Icon
                as={MbeSettings}
                color="brand.red.light"
                h={35}
                mr={6}
                w={35}
                onClick={onToggle}
              />
            </NavLink>
            <Icon as={MbeClose} h={35} stroke="1px" w={35} onClick={onToggle} />
          </Flex>

          <Menu
            activeStyle={{
              borderLeft: '8px solid red',
              paddingInlineStart: '7px',
            }}
            linkProps={{
              paddingTop: 3,
              paddingInlineStart: '15px',
              paddingBottom: 4,
            }}
            listProps={{
              color: 'black',
              display: 'flex',
              flexDirection: 'column',
              flex: '1 1 0',
              gap: 4,
              maxH: 'calc(100vh - 150px)',
              pt: 5,
            }}
            onItemClick={onToggle}
          >
            <Box px="15px">
              <Divider borderColor="black" />
            </Box>
            <Button
              _hover={{ textDecoration: 'none' }}
              display="block"
              paddingInlineStart="15px"
              textAlign="left"
              variant="link"
              // eslint-disable-next-line @typescript-eslint/no-misused-promises
              onClick={logout}
            >
              {t('ACCOUNT.MENU.LOGOUT')}
            </Button>
          </Menu>
          <Box px={8}>
            <Button
              as="a"
              href={`/${ROUTE_PATHS.quote}`}
              variant={{ base: 'mbeSecondary', md: 'mbeSecondaryDark' }}
              w="full"
            >
              {t('ACCOUNT.MENU.CTA')}
            </Button>
          </Box>
        </Flex>
      </Slide>
    </>
  );
};
